var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isImpersonated
    ? _c("base-icon", {
        staticClass: "_tc--accent",
        attrs: { name: "id-card", size: "lg", "is-fixed-width": "" },
      })
    : _vm.hasAvatar
    ? _c("base-image", {
        staticClass: "gfu-avatar",
        attrs: {
          alt: "Avatar",
          src: _vm.userProfileAvatarUrl,
          width: _vm.avatarSize,
          height: _vm.avatarSize,
          "data-qa": "header-actions:Avatar",
        },
      })
    : _c("base-icon", {
        attrs: { name: "user-cog", size: "lg", "is-fixed-width": "" },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }